module.exports = __webpack_public_path__ + "static/img/icon_thunder.3eb104b7.png";